/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * The identification method is able to unequivocally recognize the Client in the system with the information from official documents or identification reference in its country
 */
export interface IdentificationMethod {
  /**
   * Unique Id for the Identity Document
   */
  identityMethodId?: string;
  /**
   * Indicates the type for the identity document, for example: 01 - CIF / NIF, 02 - DNI, 03 - DUI, 04 - NIT, 05 - Driver's license, 06 - Resident card, 07 - Tax registration, 08 - RUT, 09 - TDI, 10 - RTN, 11 - CED , 12 - RNC, 13 - RUC, 98 - Temporary, 99 - Passport
   */
  identityDocumentTypeCode?: string;
  /**
   * Indicates the description for the identity document
   */
  identityDocumentTypeDesc?: string;
  /**
   * Indicates the Identity document number
   */
  identityDocumentNumber?: string;
  /**
   * Relates the expiration date for the document
   */
  identityDocumentExpirationDate?: Date;
  /**
   * Relates the expedition date for the document record
   */
  identityDocumentExpeditionDate?: Date;
  /**
   * Indicates if the document is the preferred by the client
   */
  preferenceIdentityDocumentInd?: boolean;
  /**
   * Field to inform the person fiscal code. (6 letters, 2 numbers, 1 letter, 2 numbers, 1, letter, 3 numbers, 1 letter)
   */
  fiscalCode?: string;
}
